export function areFolderIdsDifferent(prevFolderIds: string[], folderIds: string[]): boolean {
    if (folderIds.length !== prevFolderIds.length) {
        return true;
    }
    prevFolderIds.sort();
    folderIds.sort();
    const folderIdsAreEqual = folderIds.every((value, index) => value === prevFolderIds[index]);
    return !folderIdsAreEqual;
}
